import React, { useEffect, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import LoadEvents from "./LoadEvents";
import moment from "moment";
import { useSelector } from "react-redux";
import { storeStateType } from "../../../redux/store";
import WeekHead from "./WeekHead";
import { IScheduleEvent } from "../../../redux/reducers/schedule.reducer";
import Loading from "react-loading";
import {
  IFacilityOption,
  eventForm,
} from "../../CalendarForms/Types/calendarTypes";
import { filterEventsType } from "../../../redux/actions/schedule.actions";
import { siteSettingsType } from "../../../redux/reducers/settings.reducer";

type weekType = {
  date: string;
  fullDate: string;
};

type WeekCalendarPropsType = {
  overallSelectedDate: string;
  selectedFacility: null | IFacilityOption;
  setShowingEventForm: React.Dispatch<React.SetStateAction<eventForm>>;
  allEvents: IScheduleEvent[];
  setShowEditModal: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedEvent: React.Dispatch<React.SetStateAction<IScheduleEvent | null>>;
  filterByWorktype: string[];
  setFilterEvents: React.Dispatch<React.SetStateAction<filterEventsType>>;
  setShowAssignEmployeeModal: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function WeekCalendar(props: WeekCalendarPropsType) {
  const {
    overallSelectedDate,
    selectedFacility,
    setShowingEventForm,
    allEvents,
    setSelectedEvent,
    setShowEditModal,
    filterByWorktype,
    setFilterEvents,
    setShowAssignEmployeeModal,
  } = props;
  let themeMode = useSelector((state: storeStateType) => state.UI.themeMode);

  const { work_types } = useSelector((state: storeStateType) => state.schedule);

  const { loading } = useSelector((state: storeStateType) => state.schedule);

  const { settings } = useSelector(
    (state: storeStateType) => state.sitesetting
  );
  const [startDay, setStartDay] = useState<number | null>(null);

  useEffect(() => {
    if (settings) {
      settings.forEach((config: siteSettingsType) => {
        if (config["config_name"] === "timesheet") {
          let timesheetSetting = JSON.parse(config["config_value"]);
          if (timesheetSetting?.start_day) {
            setStartDay(timesheetSetting.start_day);
          } else {
            setStartDay(1);
          }
        }
      });
    }
  }, [settings]);

  const [week, setWeek] = useState<weekType[]>([]);

  const [dayStringState, setDayStringState] = useState<string[]>([]);

  //from which day the day week should start #for day string
  useEffect(() => {
    if (startDay) {
      let daysString = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];
      let chopedDays = daysString.splice(startDay, 7);
      chopedDays.push(...daysString);
      let calculatedDaysString = chopedDays;
      setDayStringState(calculatedDaysString);
    }
  }, [startDay]);

  useEffect(() => {
    if (startDay) {
      let shiftedDate = moment(overallSelectedDate)
        .subtract(startDay, "days")
        .format("YYYY-MM-DD");
      let date = new Date(shiftedDate); //selected date

      //making weeks days from selected day
      function processWeek() {
        let day: number = date.getDay(); //current day ( which day of week) 0-sunday 6-friday
        let offSetDay = day; //changing the start day (indexing)
        let week: { date: string; fullDate: string }[] = [];
        for (let i = 0; i < 7; i++) {
          let momentObj = moment(overallSelectedDate); //selected date momentobj date

          //momentObj is mutable in each query

          //getting front days and current date from selected date
          if (offSetDay >= 0) {
            let fullDate = momentObj
              .subtract(offSetDay, "days")
              .format("YYYY-MM-DD");
            let dateArray = fullDate.split("-");

            week.push({ date: dateArray[2], fullDate: fullDate });
            offSetDay--;
            continue;
          }
          //getting back dates from selected date

          let date = momentObj
            .add(Math.abs(i - day), "days")
            .format("YYYY-MM-DD");
          let dateArray = date.split("-");

          week.push({ date: dateArray[2], fullDate: date });
        }
        setWeek([...week]);
        if (week[0]?.fullDate) {
          setFilterEvents((preState) => {
            return {
              ...preState,
              start_date: week[0]?.fullDate,
              end_date: week[6]?.fullDate,
            };
          });
        }
      }
      processWeek();
    }
    return () => {
      setWeek([]);
    };
  }, [overallSelectedDate, startDay, setFilterEvents]);
  function renderWeekHeads() {
    return week.map((day, index) => {
      return (
        <WeekHead
          key={index}
          date={day.date}
          fullDate={day.fullDate}
          dayString={dayStringState[index]}
          setShowingEventForm={setShowingEventForm}
          allEvents={allEvents}
          setShowEditModal={setShowEditModal}
          setSelectedEvent={setSelectedEvent}
          selectedFacility={selectedFacility}
          filterByWorktype={filterByWorktype}
          setShowAssignEmployeeModal={setShowAssignEmployeeModal}
        />
      );
    });
  }

  function renderEvents(workfield: any) {
    return (
      <Box display={"flex"}>
        {week.map((day, index) => {
          return (
            <LoadEvents
              key={index}
              workfield={workfield}
              date={day.date}
              fullDate={day.fullDate}
              dayString={dayStringState[index]}
              setShowingEventForm={setShowingEventForm}
              allEvents={allEvents}
              setShowEditModal={setShowEditModal}
              setSelectedEvent={setSelectedEvent}
              selectedFacility={selectedFacility}
              filterByWorktype={filterByWorktype}
              setShowAssignEmployeeModal={setShowAssignEmployeeModal}
            />
          );
        })}
      </Box>
    );
  }

  let scheduledWorkTypes: string[] = [];
  allEvents.forEach((scheduleEvent) => {
    if (!scheduledWorkTypes.includes(scheduleEvent.work_type)) {
      scheduledWorkTypes.push(scheduleEvent.work_type);
    }
  });
  return (
    <Grid container sx={{ height: "60vh" }}>
      {renderWeekHeads()}
      {loading && (
        <Box
          height={"100%"}
          width={"100%"}
          display="flex"
          alignItems={"center"}
          justifyContent={"center"}
        >
          <Loading
            type="bars"
            color={themeMode === "dark" ? "#fcfcfc" : "#000000"}
            height={100}
            width={100}
          />
        </Box>
      )}
      {!loading && (
        <Box width="100%" height="100%" sx={{ overflowY: "scroll" }}>
          {work_types.map((workfield) => {
            if (
              (filterByWorktype.length === 0 ||
                filterByWorktype.includes(workfield.id)) &&
              scheduledWorkTypes.includes(workfield.id)
            ) {
              return (
                <Box
                  key={workfield.id}
                  width={"100%"}
                  display="flex"
                  flexDirection="column"
                  style={{ margin: "0.3rem 0", paddingBottom: "20px" }}
                  borderBottom="1px solid "
                  borderColor="text.primary"
                >
                  <>
                    <Typography
                      variant="subtitle2"
                      fontWeight={600}
                      m={1}
                      display={"block"}
                      textAlign="start"
                    >
                      {workfield.name}
                    </Typography>
                    {renderEvents(workfield)}
                  </>
                </Box>
              );
            }
            return null;
          })}
        </Box>
      )}
    </Grid>
  );
}
